import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, distinctUntilChanged, map, Observable, take } from 'rxjs';

import { ModalsActions } from 'src/app/features/modals';
import { PackageUsersSelectors } from 'src/app/features/package-users';
import { getFullNames, PackageUserWithDisplayName } from 'src/app/features/package-users/util';
import { RootStoreState } from 'src/app/store';
import { SigningRoomActions } from '../../store';
import { DeviceGroupSelectors } from 'src/app/features/device-group';

@Component({
  selector: 'app-session-add-participant-modal',
  templateUrl: './session-add-participant-modal.component.html',
  styleUrl: './session-add-participant-modal.component.scss',
  standalone: false,
})
export class SessionAddParticipantModalComponent implements OnInit {
  static identifier = 'SessionAddParticipantModalComponent';

  nonSigningAgentsEligibleForAddSession$: Observable<PackageUserWithDisplayName[]>;
  isAddUserButtonEnabled = false;
  selectedParticipant: PackageUserWithDisplayName = null;

  constructor(private readonly store: Store<RootStoreState.State>) {}

  ngOnInit(): void {
    this.nonSigningAgentsEligibleForAddSession$ = combineLatest([
      this.store.select(DeviceGroupSelectors.getUsersOnDevice),
      this.store.select(PackageUsersSelectors.getNonSigningAgents),
    ]).pipe(
      map(([usersOnDevice, nonSAs]) => {
        return nonSAs.filter(
          (nonSA) => !usersOnDevice.some((d) => d.packageUserGuid === nonSA.packageUserGuid)
        );
      }),
      distinctUntilChanged((prev, curr) => {
        return (
          JSON.stringify(prev.map((u) => u.packageUserGuid)) ===
          JSON.stringify(curr.map((u) => u.packageUserGuid))
        );
      }),
      map((eligibleUsers) => {
        return getFullNames(eligibleUsers);
      })
    );
  }

  back() {
    this.store.dispatch(ModalsActions.ClearModalComponent());
  }

  acceptAddParticipant(_) {
    return this.store.dispatch(
      SigningRoomActions.PromptUserForAuthentication({
        payload: { participant: this.selectedParticipant },
      })
    );
  }

  onParticipantClicked(participant: PackageUserWithDisplayName) {
    if (this.selectedParticipant?.packageUserGuid === participant.packageUserGuid) {
      this.selectedParticipant = null;
    } else {
      this.selectedParticipant = participant;
    }

    this.isAddUserButtonEnabled = !!this.selectedParticipant;
  }
}
